import React, { FC } from 'react';

import { Select } from '@chakra-ui/select';
import { FormControl, FormLabel } from '@chakra-ui/form-control';

import { useFormikContext } from 'formik';
import { washHub } from 'store/slices';
import { useQuery } from 'react-query';
import { fetchSites } from 'api/site';

import { SiteSelectProps } from './SiteSelect.props';

const SiteSelectView: FC<SiteSelectProps> = (props) => {
  const { containerProps, labelProps, onChange } = props;
  const isWashHubIdValid = washHub.selectors.useIsWashHubIdValid();
  const { values, setFieldValue } = useFormikContext<any>();
  const washHubId = washHub.selectors.useSelectedWashHubId();
  const queryKey = ['fetch-sites-active', washHubId];
  const queryFn = () => fetchSites(washHubId, 1);

  const { data = [] } = useQuery(queryKey, queryFn, {
    enabled: isWashHubIdValid, // Ensure query is only enabled when washHubId is truthy
  });

  return (
    <FormControl mt={2} {...containerProps}>
      <FormLabel
        htmlFor="site"
        color={containerProps?.isDisabled ? '#333' : '#afafaf'}
        fontSize="12px"
        textTransform="capitalize"
        {...labelProps}>
        Customer Site
      </FormLabel>
      <Select
        value={values?.site}
        placeholder="Select option"
        color="support.500"
        iconColor="support.500"
        textColor="support.500"
        onChange={(e) => {
          const site = e.target.value;
          const siteCode = data?.find((s) => s._id === site)?.code;

          setFieldValue('site', site);
          setFieldValue('siteCode', siteCode);

          onChange?.(site);
        }}>
        {data?.map((i) => (
          <option value={i._id} key={`${i._id}`}>
            {i.name}
          </option>
        ))}
      </Select>
    </FormControl>
  );
};

export default SiteSelectView;
